<div class="toast warning">
  <motif-icon
    [iconFunction]="IconoirWhiteFlag"
    class="flag-icon"
    size="24"
  ></motif-icon>

  <div>
    <p class="toast-title">
      We have identified {{ flaggedItems.length }} out of
      {{ fullData.length }} items that require your attention
    </p>
  </div>
</div>
